import { render } from "./myleaves-svg.vue?vue&type=template&id=766a7fb8"
const script = {}

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__